import React from 'react';
import { DEFAULT_LOCALE } from './config';

const I18nContext = React.createContext({
  locale: DEFAULT_LOCALE,
  // eslint-disable-next-line no-console
  setLocale: (_locale: string) => console.log('setLocale handler should be defined')
});

export default I18nContext;
